export class loadingBackground {

	private parent: PIXI.Container;
	private background: PIXI.Graphics;
	constructor(parent: PIXI.Container) {
		this.parent = new PIXI.Container();
		parent.addChild(this.parent);
		this.background = new PIXI.Graphics();
		this.background.beginFill(0x00ff00);
		this.background.drawRect(0, 0, 1920, 1080);
		this.background.endFill();
		this.background.x = 0;
		this.background.y = 0;
		this.parent.addChild(this.background);
		this.background.alpha=0;

	}

	public getParent= ():PIXI.Container=>
	{
		return this.parent;
	}


}
